"use client";

import generalSlice from "@/app/store/slices/general";
import { combineReducers, configureStore } from "@reduxjs/toolkit";

import addressSlice from "@/app/store/slices/address/addressSlice";
import cartSlice from "@/app/store/slices/cart/cartSlice";
import tryCartSlice from "@/app/store/slices/try-cart/tryCartSlice";
import adminBarSlice from "@/app/store/slices/adminBar/adminBarSlice";


export const rootReducer = combineReducers({
  cart: cartSlice.reducer,
  tryCart: tryCartSlice.reducer,
  address: addressSlice.reducer,
  general: generalSlice.reducer,
  adminBar: adminBarSlice.reducer,
});

export const makeStore = (preloadedState?: Partial<RootState>) => {
	return configureStore({
		reducer: rootReducer,
		preloadedState,
		middleware: (getDefaultMiddleware) => {
			return getDefaultMiddleware();
		},
	});
};

// Infer the type of makeStore
export type AppStore = ReturnType<typeof makeStore>;
// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof rootReducer>;
export type AppDispatch = AppStore["dispatch"];
